<template>
  <validation-observer ref="observer" v-slot="{ passes }">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ titulo }}
        </p>
      </header>
      <div class="modal-card-body">
        <section>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Ubicación Folio"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input v-model="model.ubicacion" type="text" />
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Observación"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input
                v-model="model.observacion"
                type="textarea"
                maxlength="256"
              />
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Usuario Asignado"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-select
                v-model="model.usuarioId"
                placeholder="Seleccione una opción..."
              >
                <option
                  v-for="(item, index) in usuarios"
                  :key="`usuario-${index}`"
                  :value="item.id"
                >
                  {{ item.nombre }}
                </option>
              </b-select>
            </b-field>
          </validation-provider>
        </section>
        <section>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="cargarArchivoAuditoria" type="is-info">
                Cargar archivo de auditor&iacute;a?
              </b-checkbox>
            </b-field>
          </validation-provider>
        </section>
        <section v-show="cargarArchivoAuditoria">
          <b-field v-if="!archivoFolio" label="Archivo de Auditoría">
            <b-upload v-model="archivoFolio" drag-drop>
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                    <b-icon icon="upload" size="is-large"> </b-icon>
                  </p>
                  <p>Arrastre su archivo de auditor&iacute;a aqu&iacute;</p>
                </div>
              </section>
            </b-upload>
          </b-field>
          <div v-else class="tags">
            <span class="tag is-primary">
              {{ archivoFolio.name }}
              <button
                class="delete is-small"
                type="button"
                @click="deleteFile()"
              ></button>
            </span>
          </div>
        </section>
      </div>
      <footer class="modal-card-foot">
        <div class="buttons">
          <b-button type="is-info" :disabled="posting" @click="passes(submit)">
            <b-icon
              v-show="posting"
              pack="fas"
              icon="sync-alt"
              custom-class="fa-spin"
            >
            </b-icon>
            <span>Guardar</span>
          </b-button>
          <button :disabled="posting" class="button" @click="cerrarForm">
            <span>Salir</span>
          </button>
        </div>
      </footer>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import { mapGetters } from 'vuex'

import { bodegaService, inventarioService } from '@/services'

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})

export default {
  name: 'FolioForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    titulo: {
      type: String,
      default: 'Agregar Folio'
    },
    recuento: {
      type: Number,
      default: 0
    },
    objeto: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data: () => ({
    model: {},
    cargarArchivoAuditoria: false,
    archivoFolio: null,
    usuarios: [],
    cargando: false,
    posting: false
  }),
  computed: {
    ...mapGetters('sesion', ['bodega']),
    postModel() {
      return Object.assign(this.model, { recuentoId: this.recuento })
    }
  },
  watch: {
    archivoFolio() {
      this.model.contieneArchivo = !!this.archivoFolio
    }
  },
  async created() {
    await this.getUsuarios()
    this.model = this.modeloInicial()
  },
  mounted() {
    this.model = Object.assign(this.model, this.objeto)
  },
  methods: {
    async submit() {
      const self = this
      self.posting = true
      try {
        if (this.model.contieneArchivo) {
          const response = await inventarioService.uploadFolioFile(
            this.archivoFolio
          )
          this.model.archivoFolio = response.data.fileName
          this.model.puedeModificar = true
          this.model.esAuditoria = true
        }
        await inventarioService.addFolio(self.postModel)
        self.notificarAccionCompletada('Se agregó folio correctamente')
        self.$emit('close', true)
      } catch (error) {
        self.procesarError(error)
      } finally {
        self.posting = false
      }
    },
    cerrarForm() {
      this.$emit('close', false)
    },
    resetForm() {
      this.model = this.modeloInicial()
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    getUsuarios() {
      const self = this
      return bodegaService
        .getUsuariosByBodega(this.bodega.id)
        .then((response) => (self.usuarios = response.data))
        .catch((error) => this.procesarError(error))
    },
    modeloInicial() {
      return {
        ubicacion: null,
        observacion: null,
        usuarioId: null,
        puedeModificar: false,
        contieneArchivo: false
      }
    },
    deleteFile() {
      this.archivoFolio = null
    }
  }
}
</script>
